
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment, useEffect, useState } from "react";
import Select from "react-select";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Accordion from '../../accordion'
import FileSaver from "file-saver";

// ../../../../images/candidate/upload.png
//  download fill

import Upload from "../../../../images/candidate/download.svg";
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Button,
    Form,
    Input,
} from "reactstrap";

import pdf from "../../images/document.svg";
import { NextButton, NumberInput, SelectInput, TextInput } from "./UserInputs";
import { useForm } from "react-hook-form";
import { useProfilecontext } from "../Editprofileprovider";
import { createFormData , scroll_to_top} from "../../../common/utils";
import ReviewModel from "./ReviewModel";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import request, { client } from "../../../../api/api";




export default function PaymentDetailTab () {

    const [ state , dispatch ] = useProfilecontext();
    const { updateForm } = state || {} ;
    const domhistory = useHistory()
    const { register , handleSubmit , formState:{errors}} = useForm({
        // resolver
        values:{
            bankName:state.bankName,
            accountType:state.accountType,
            accountName:state.accountName,
            bank_sort_code:state.bank_sort_code,
            bank_ac_name:state.bank_ac_name,
            top_size:state.top_size,
        },
        mode:"onTouched"
    });
    const [IsReview , setIsReview] = useState(false);
    const [active_accordion , setActiveAccordion ] = useState(0)

    let tosatId;

    const redirect_to = (path="/profile/viewprofile" , state={})=>{
        domhistory.push({pathname:path ,state })
    }
    const toggleTab = (tab = '', tabId = '') => {
        // setActiveAccordion(0)
        dispatch({ type: "TOGGLE_TAB", payload: { tab, tabId } })
        scroll_to_top()
    }

    const handleSetToast = ({id = '' , message = '' , type = ''})=>{
        dispatch({type:"SET_TOAST" , payload:{ id, message , type}})
    }

    const handleonReview = (e , action = '') =>{
        if(action === 'ok_submit'){
            if(updateForm){
                updateForm({application_status:1 , setctionId:"application_status"})
                .then(()=>{
                    setIsReview((prev)=>!prev)
                    redirect_to()
                    toast.success("Thank you, your profile/application has been submitted, we will be in touch soon");                
                })
            }
            return;
        }
        if(action === 'download'){
            downloadProfile().then(()=>{
                setIsReview((prev)=>!prev)
                redirect_to()
            })
            return;
        }
        setIsReview((prev)=>!prev)
    }


    const downloadProfile = async ()=>{
            let toastId = "referee_form_download_022";
            toastId = toast.info("Downloading......", { autoClose: 7500 });
            request({
                url: "/candidate/onlineform/download/pdf",
                method: "POST",
                data: {
                    host: window.location.hostname,
                    protocol: window.location.protocol,
                    port: window.location.port
                },
                responseType:"blob"
            }).then((res) => {
                if (res) {
                    toast.update(toastId, { render: "Downloaded!", type: toast.TYPE.SUCCESS, autoClose: 2500 });
                    const file = new Blob([res], { type: "application/pdf" });
                    FileSaver(file, `${this.state.prefix_name} Application form.pdf`);
                } else {
                    toast.error(res.response);
                }
            }).catch((error) => {
                toast.update(toastId, { render: error, type: toast.TYPE.ERROR, autoClose: 2500 });
            });
    }
    const onFormSubmit = (data ={}) =>{
        const payment_details = createFormData({...data , setctionId:"payment_details"})
        if(updateForm){
            updateForm(payment_details).then(()=>{
                handleSetToast({ id:"payment_details" , message:"saved!" ,type:"success" })
            }).finally(()=>{
                setIsReview((prev)=>!prev);        
            })
        }

    }



    

    return (
    <Form onSubmit={handleSubmit(onFormSubmit)}>
        <Accordion open={active_accordion} toggleAccordion={setActiveAccordion}>
            <Accordion.Item>
                <Accordion.Header>
                    Your Bank Account Details
                </Accordion.Header>
                <Accordion.Body>
                        <div className="position-relative col-12 col-md-12 p-0 d-flex flex-wrap">

                            <TextInput label="Name of Bank/Building Society" placeholder='Name of Bank/Building Society' {...register("bankName")} />

                            <SelectInput label="Account Type" options={['Personal' ,"Limited Company"]} {...register("accountType")}/>

                            <TextInput label="Account Name" placeholder='Account Name' {...register("accountName")} />

                            <TextInput label="Sort Code" error={errors.bank_sort_code && errors.bank_sort_code.message} placeholder='Sort Code' {...register("bank_sort_code" , {validate:(v)=>!isNaN(v) || "Invalid code" , minLength:{value:6 ,message:"Invalid code"} , maxLength:{ value:6 , message:"Invalid code" } })} maxLength={6} />

                            <TextInput label="Account Number" error={errors.bank_ac_name && errors.bank_ac_name.message}  placeholder='Account Number' {...register("bank_ac_name",{ validate:(v)=>!isNaN(v) || "Invalid Ac No." , minLength:{value:8 ,message:"Invalid Ac No."} , maxLength:{ value:8 , message:"Invalid Ac No." } })} maxLength={8} />

                            <NextButton type={"button"} onClick={()=>setActiveAccordion(1)} />
                        </div>    
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item>
                <Accordion.Header>
                    Uniform Details
                </Accordion.Header>
                <Accordion.Body>
                        <div className="position-relative col-12 col-md-12 p-0 d-flex flex-wrap">
                            <SelectInput label="Top Size" options={['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL']} {...register("top_size")}/>


                        </div>    
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
        <div className="position-relative col-12 col-md-12">
            <div className="mt-0 text-center three_button" id="s-c-buttons">
                <Button onClick={()=>toggleTab("menu" ,"4")}><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Previous</Button>
                <Button className="btn-save">Submit</Button>
            </div>
        </div>
        <ReviewModel isOpen={IsReview} toggle={handleonReview}  />

    </Form>

    )
}


/*
 
*/